import { Link } from 'react-router-dom';

const LAST_UPDATED = 'February 3, 2026';

export const TermsPage = () => (
  <div className="min-h-screen bg-[#FBF6EC]">
    <div className="max-w-3xl mx-auto px-6 py-14">
      <Link to="/" className="text-[#D95A41] hover:underline text-sm">← Back to home</Link>
      <h1 className="text-4xl font-bold text-[#2A2320] mt-4">Terms of Service</h1>
      <p className="text-sm text-neutral-600 mt-2">Last updated: {LAST_UPDATED}</p>

      <div className="mt-8 space-y-6 text-[#2A2320] leading-relaxed">
        <p>
          Welcome to Eat From Local. By creating an account or using the Service (the website{' '}
          <a href="https://eatfromlocal.com" className="text-[#D95A41] underline">eatfromlocal.com</a>{' '}
          and the Eat From Local mobile app), you agree to these Terms. Please read them carefully.
        </p>

        <section>
          <h2 className="text-xl font-bold mb-2">1. Who can use it</h2>
          <p>You must be at least 18 years old and able to enter a binding contract. If you sign up on behalf of a business, you confirm you have the authority to bind that business.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">2. What Eat From Local is (and isn't)</h2>
          <p>
            Eat From Local is a <strong>marketplace</strong> that connects home cooks ("Cooks") with
            people who want to eat homemade food ("Buyers"). We are not a restaurant, food producer,
            delivery service, or party to any transaction between Cooks and Buyers. Any dish posted
            on the Service is prepared, sold, and delivered by the Cook — <em>not</em> by us.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">3. Cook responsibilities</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Comply with all local food-safety, hygiene, licensing, and tax laws in your jurisdiction.</li>
            <li>Accurately describe every dish, including ingredients, allergens (nuts, dairy, gluten, shellfish, etc.), and portion size.</li>
            <li>Only post dishes you can legally sell where you live.</li>
            <li>Honour orders that Buyers place through the chat within a reasonable time.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">4. Buyer responsibilities</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Read every listing carefully, especially allergen information, before ordering.</li>
            <li>Pay Cooks directly using whatever payment method you agree on in chat.</li>
            <li>Treat Cooks with respect. Harassment, hate speech, or spam gets you banned.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">5. Prohibited content</h2>
          <p>You may not post: alcohol, drugs, unpasteurised dairy, unregulated meat, anything that violates food-safety law, hate speech, adult content, or infringing material. We reserve the right to remove any listing or account without notice.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">6. Fees</h2>
          <p>The Service is currently free to use. If we introduce fees in the future, we will notify you at least 30 days in advance and give you the chance to close your account first.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">7. Disclaimer of warranties</h2>
          <p>
            The Service is provided <em>"as is"</em>. We do not guarantee the quality, safety, legality,
            or accuracy of any dish or listing. Food-related transactions are entirely between Cook and Buyer.
            <strong> Eat From Local is not liable for any illness, injury, allergic reaction, damages, or loss</strong>{' '}
            arising from a transaction facilitated by the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">8. Limitation of liability</h2>
          <p>To the maximum extent permitted by law, Eat From Local's total liability to you for any claim relating to the Service is limited to AUD $100.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">9. Termination</h2>
          <p>We may suspend or terminate your account at any time for breach of these Terms or applicable law. You may close your account at any time from your profile page or by emailing <a href="mailto:privacy@eatfromlocal.com" className="text-[#D95A41] underline">privacy@eatfromlocal.com</a>.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">10. Changes to these Terms</h2>
          <p>We may update these Terms from time to time. Material changes will be announced via email or an in-app banner at least 14 days before they take effect.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">11. Governing law</h2>
          <p>These Terms are governed by the laws of New South Wales, Australia. Any dispute will be resolved in the courts of NSW.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">12. Contact</h2>
          <p>Questions? Email <a href="mailto:hello@eatfromlocal.com" className="text-[#D95A41] underline">hello@eatfromlocal.com</a>.</p>
        </section>
      </div>

      <div className="mt-12 pt-6 border-t border-[#E5D9C0] text-sm text-neutral-600">
        <Link to="/privacy" className="text-[#D95A41] hover:underline">Privacy Policy</Link>
      </div>
    </div>
  </div>
);

export default TermsPage;
